interface Store {
  config: any;
  state: { start: string; end: string };
}

export class SelectBtn {
  public node: HTMLInputElement;
  private name: string;
  private activeClassName: string;

  constructor({
    node,
    store,
    type,
    inactiveSelectNodes,
    resetInputNodes,
  }: {
    node: HTMLInputElement;
    store: Store;
    type: 'start' | 'end';
    inactiveSelectNodes: () => void;
    resetInputNodes: () => void;
  }) {
    this.node = node;
    this.name = node.dataset.searchName || '';
    this.activeClassName = store.config.className.activeSelectBtn;

    this.node.addEventListener('change', () => {
      inactiveSelectNodes();
      resetInputNodes();

      this.node.classList.add(this.activeClassName);
      store.state[type] = this.name;
    });
  }
}
